/**
 * IMPROVED DRAG HANDLE (RECOMMENDED)
 * 
 * This component replaces MobileReorderControls with a universal drag handle
 * that works on both mobile and desktop devices.
 * 
 * Benefits:
 * - Single component for all devices
 * - Familiar pattern (users know ≡ means draggable)
 * - Works with existing @hello-pangea/dnd
 * - Minimal code changes
 */

import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';
import './ImprovedDragHandle.css';

function ImprovedDragHandle({ itemId, index, totalItems, dragHandleProps }) {
    const { t } = useTranslation();
    return (
        <div className="improved-drag-handle">
            {/* Drag Handle Icon */}
            <div className="drag-handle-wrapper">
                <Tooltip 
                    target={`.drag-handle-${itemId}`} 
                    content={t('dragdrop.drag_to_reorder')}
                    position="top" 
                    className="fs-8" 
                />
                <div
                    className={`drag-handle-icon drag-handle-${itemId}`}
                    {...(dragHandleProps || {})}
                >
                    <i className="fas fa-bars text-light"></i>
                </div>
            </div>

            {/* Optional: Position Indicator */}
            <div className="position-indicator">
                <span className="position-text">{index + 1}/{totalItems}</span>
            </div>
        </div>
    );
}

export default ImprovedDragHandle;
